import { render, staticRenderFns } from "./PleurisyTable.vue?vue&type=template&id=7a7d9de3&scoped=true&"
import script from "./PleurisyTable.vue?vue&type=script&lang=ts&"
export * from "./PleurisyTable.vue?vue&type=script&lang=ts&"
import style0 from "./PleurisyTable.vue?vue&type=style&index=0&id=7a7d9de3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7d9de3",
  null
  
)

export default component.exports